// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetSearchCatalogLocationRequest,
  TGetSearchCatalogLocationModel,
  IMappers,
  TGetSearchCatalogLocationResponse,
  IGetSearchCatalogLocationResponse,
  IGetSearchCatalogLocationResponseError,
} from './types';

export const defaultConfig: TGetSearchCatalogLocationModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'geo-temp-layer',
  pathApi: '/v1/get-search-catalog-location/',
} as TGetSearchCatalogLocationModel;

export function createGetSearchCatalogLocationModel(
  parameters: IGetSearchCatalogLocationRequest,
): TGetSearchCatalogLocationModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetSearchCatalogLocationOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetSearchCatalogLocationRequest;
}

export async function fetchGetSearchCatalogLocation<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetSearchCatalogLocationOptions<TResponse200, TResponse400>): Promise<
  TGetSearchCatalogLocationResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(
    createGetSearchCatalogLocationModel(parameters),
    config,
  );
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetSearchCatalogLocationResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetSearchCatalogLocationResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetSearchCatalogLocationResponse;
}
